(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../button", "../icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../button"), require("../icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.button, global.icon);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _button, _icon) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _button = _interopRequireDefault(_button);
  _icon = _interopRequireDefault(_icon);

  var _components;

  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('transition', {
        attrs: {
          "name": "nx-snack-bar"
        }
      }, [_vm.isSnackBarShow ? _c('div', {
        class: ['nx-snack-bar', "nx-snack-bar-type-" + _vm.type, "nx-snack-bar-placement-" + _vm.placement, _vm.isTwoLine ? 'nx-snack-bar-two-line' : '', _vm.hasOutline ? 'nx-snack-bar-outline' : '', _vm.hasBoxShadow ? 'nx-snack-bar-shadow' : '', !_vm.isNormalShowAnim || _vm.initShow ? '' : 'nx-snack-bar-show-animation'],
        attrs: {
          "aria-label": _vm.ariaLabelContent || _vm.snackBarTitle + "," + _vm.snackBarContext,
          "tabindex": "1"
        }
      }, [_c('div', {
        staticClass: "nx-snack-bar-content",
        on: {
          "click": _vm.$_handleMainClick
        }
      }, [_vm.leftIcon ? _c('div', {
        staticClass: "nx-snack-bar-left",
        class: {
          'nx-snack-bar-large-icon': _vm.iconSize == 'large'
        },
        attrs: {
          "aria-hidden": "true"
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.leftIcon
        }
      })]) : _vm._t("left"), _c('div', {
        staticClass: "nx-snack-bar-center",
        attrs: {
          "aria-hidden": "true"
        }
      }, [_vm.snackBarTitle ? _c('div', {
        staticClass: "nx-snack-bar-title",
        attrs: {
          "id": "titleId"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.snackBarTitle)
        }
      }) : _vm._e(), _vm.snackBarContext ? _c('div', {
        staticClass: "nx-snack-bar-desc",
        attrs: {
          "id": "contextId"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.snackBarContext)
        }
      }) : _vm._e()]), _c('div', {
        staticClass: "nx-snack-bar-right"
      }, [_vm.$slots.right ? [_vm._t("right")] : _c('nx-button', {
        staticClass: "nx-snack-bar-btn",
        attrs: {
          "size": "small",
          "type": _vm.btnType,
          "loading": _vm.loading,
          "delay": _vm.delay,
          "tabindex": "1"
        },
        nativeOn: {
          "click": function click($event) {
            $event.stopPropagation();
            return _vm.$_handleBtnClick($event);
          }
        }
      }, [_vm._v("\n          " + _vm._s(_vm.btnContext) + "\n        ")])], 2), _vm.showCancelIcon ? _c('img', {
        staticClass: "nx-snack-bar-icon-close",
        attrs: {
          "src": "https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/ce954600-716c-11ee-b043-839c63d126b3.png",
          "role": "button",
          "aria-label": "关闭",
          "tabindex": "1"
        },
        on: {
          "click": function click($event) {
            $event.stopPropagation();
            return _vm.$_onClose($event);
          }
        }
      }) : _vm._e()], 2)]) : _vm._e()]);
    },
    name: 'nx-snack-bar',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      ariaLabelContent: {
        type: String,
        default: ''
      },
      leftIcon: {
        type: String,
        default: ''
      },
      iconSize: {
        type: String,
        default: 'normal' // 普通：normal，大图标：large

      },
      snackBarTitle: {
        type: String,
        default: ''
      },
      snackBarContext: {
        type: String,
        default: ''
      },
      btnContext: {
        required: true,
        type: String,
        default: ''
      },
      btnType: {
        type: String,
        default: 'primary'
      },
      showCancelIcon: {
        type: Boolean,
        default: true
      },
      // 悬浮模式：suspend 普通模式：normal
      type: {
        type: String,
        default: 'normal'
      },
      placement: {
        type: String,
        default: 'bottom' // top / bottom

      },
      hasOutline: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      delay: Number,
      hasBoxShadow: {
        type: Boolean,
        default: true
      },
      isNormalShowAnim: {
        type: Boolean,
        default: true
      }
    },
    components: (_components = {}, (0, _defineProperty2.default)(_components, _button.default.name, _button.default), (0, _defineProperty2.default)(_components, _icon.default.name, _icon.default), _components),
    data: function data() {
      return {
        isSnackBarShow: false,
        timeKey: null,
        isTwoLine: false,
        initShow: false // 普通摸索-默认显示-无出现动画

      };
    },
    watch: {
      value: function value(_new) {
        if (_new) {
          this.$_onShow();
        } else {
          this.$_onHide();
        }
      }
    },
    mounted: function mounted() {
      this.initShow = this.value || false;
      this.value && this.$_onShow();
    },
    destroyed: function destroyed() {
      clearTimeout(this.timeKey);
    },
    methods: {
      $_handleMainClick: function $_handleMainClick() {
        this.$emit('handleMainClick');
      },
      $_handleBtnClick: function $_handleBtnClick() {
        this.$emit('handleBtnClick');
      },
      $_onClose: function $_onClose() {
        this.$emit('input', false);
        this.$emit('onClose');
      },
      $_onShow: function $_onShow() {
        var _this = this;

        this.isSnackBarShow = true;
        this.$emit('show');
        this.handleContentLine();

        if (!this.showCancelIcon) {
          // 没有关闭按钮，则展示5S自动消失
          this.timeKey = setTimeout(function () {
            _this.$_onHide();
          }, 5000);
        }
      },
      $_onHide: function $_onHide() {
        this.isSnackBarShow = false;
        this.initShow = false;
        this.$emit('hide');
      },
      handleContentLine: function handleContentLine() {
        var _this2 = this;

        if (!!this.snackBarTitle && !!this.snackBarContext) {
          this.isTwoLine = true;
        } else {
          this.$nextTick(function () {
            _this2.isTwoLine = _this2.getIsTwoLine('titleId') || _this2.getIsTwoLine('contextId');
          });
        }
      },
      getIsTwoLine: function getIsTwoLine(elementId) {
        var element = document.getElementById(elementId);
        if (!element) return;
        var lineHeight = window.getComputedStyle(element).lineHeight.split('px')[0];
        var lines = Math.round(element.clientHeight / lineHeight);
        return lines >= 2;
      }
    }
  };
  _exports.default = _default;
});